"use client";

import { c as _c } from "react/compiler-runtime";
import { CheckOne } from "@icon-park/svg";
import clsx from "clsx";
import styles from "./OptionCard.module.css";
import OptionCardInfo from "./OptionCardInfo";
import { ChangeEvent, InputHTMLAttributes } from "react";
import Icon from "../Icon";
import Image from "../internal/Image";
import useIsMobile from "../lib/hooks/useIsMobile";
export type OptionCardProps<T> = {
  name?: string;
  value?: T;
  infoText?: string;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  image?: string;
  testId?: string;
} & Omit<InputHTMLAttributes<HTMLInputElement>, "size">;
const OptionCard = t0 => {
  const $ = _c(48);
  let children;
  let className;
  let image;
  let infoText;
  let props;
  let t1;
  if ($[0] !== t0) {
    const {
      infoText: t2,
      className: t3,
      children: t4,
      type: t5,
      image: t6,
      testId,
      ...t7
    } = t0;
    infoText = t2;
    className = t3;
    children = t4;
    t1 = t5;
    image = t6;
    props = t7;
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = image;
    $[4] = infoText;
    $[5] = props;
    $[6] = t1;
  } else {
    children = $[1];
    className = $[2];
    image = $[3];
    infoText = $[4];
    props = $[5];
    t1 = $[6];
  }
  const type = t1 === undefined ? "radio" : t1;
  const isMobile = useIsMobile();
  let t2;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = clsx("text-center", styles.content);
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== children) {
    t3 = <span className={t2}>{children}</span>;
    $[8] = children;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const content = t3;
  let t4;
  if ($[10] !== className) {
    t4 = clsx("w-full flex", className);
    $[10] = className;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = clsx("h-none w-none absolute overflow-hidden opacity-0 peer", styles.input);
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== props || $[14] !== type) {
    t6 = <input type={type} className={t5} {...props} />;
    $[13] = props;
    $[14] = type;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  const t7 = !image;
  let t8;
  if ($[16] !== image || $[17] !== t7) {
    t8 = clsx("grow relative flex flex-col cursor-pointer text-h3 transition-all border border-neutral-50 rounded-s hover-desktop:border-primary-825 peer-focus-visible:shadow-focus px-3xs peer-checked:bg-primary-800 peer-checked:text-neutral-0 peer-checked:border-primary-800  hover-desktop:text-primary-800 hover-desktop:peer-checked:bg-primary-825 group", styles.label, {
      "py-s m:py-3xs": image,
      "py-s m:py-s": t7
    });
    $[16] = image;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  const t9 = !image;
  let t10;
  if ($[19] !== t9) {
    t10 = clsx("flex justify-between", {
      "items-center": t9
    });
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = clsx("hidden", styles.icon);
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  const t12 = isMobile ? 22 : 28;
  let t13;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = ["#ffffff", "#ffffff", "currentColor", "currentColor"];
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== t12) {
    t14 = <span className="w-m flex-none"><span className={t11}><Icon icon={CheckOne} theme="multi-color" size={t12} fill={t13} /></span></span>;
    $[23] = t12;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== image) {
    t15 = image && <Image className={styles.image} src={image} width="64" height="64" alt="" />;
    $[25] = image;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  const t16 = !image && content;
  let t17;
  if ($[27] !== infoText) {
    t17 = infoText && <OptionCardInfo>{infoText}</OptionCardInfo>;
    $[27] = infoText;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  let t18;
  if ($[29] !== t17) {
    t18 = <span className="w-m flex-none">{t17}</span>;
    $[29] = t17;
    $[30] = t18;
  } else {
    t18 = $[30];
  }
  let t19;
  if ($[31] !== t10 || $[32] !== t14 || $[33] !== t15 || $[34] !== t16 || $[35] !== t18) {
    t19 = <span className={t10}>{t14}{t15}{t16}{t18}</span>;
    $[31] = t10;
    $[32] = t14;
    $[33] = t15;
    $[34] = t16;
    $[35] = t18;
    $[36] = t19;
  } else {
    t19 = $[36];
  }
  let t20;
  if ($[37] !== content || $[38] !== image) {
    t20 = image && <span className="flex justify-center mt-2xs">{content}</span>;
    $[37] = content;
    $[38] = image;
    $[39] = t20;
  } else {
    t20 = $[39];
  }
  let t21;
  if ($[40] !== t19 || $[41] !== t20 || $[42] !== t8) {
    t21 = <span className={t8}>{t19}{t20}</span>;
    $[40] = t19;
    $[41] = t20;
    $[42] = t8;
    $[43] = t21;
  } else {
    t21 = $[43];
  }
  let t22;
  if ($[44] !== t21 || $[45] !== t4 || $[46] !== t6) {
    t22 = <label className={t4}>{t6}{t21}</label>;
    $[44] = t21;
    $[45] = t4;
    $[46] = t6;
    $[47] = t22;
  } else {
    t22 = $[47];
  }
  return t22;
};
export default OptionCard;